<div class="password-reset">
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title> {{ 'Passwort zurücksetzen' | translate }} </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="resetPasswordForm" *ngIf="!resetPasswordEmailSent">
        <mat-form-field class="full-width">
          <mat-label>{{ 'E-Mail' | translate }} </mat-label>
          <input
            matInput
            type="text"
            formControlName="email"
            autofocus
            id="email"
            placeholder="{{ 'E-Mail' | translate }}"
            required
          />
        </mat-form-field>
        <button
          mat-flat-button
          color="warn"
          type="submit"
          (click)="resetPassword()"
          id="reset-password-button"
          [disabled]="resetPasswordForm.invalid"
        >
          {{ 'Zurücksetzen' | translate }}
        </button>
      </form>

      <div *ngIf="resetPasswordEmailSent">
        <mat-card-subtitle>
          {{
            'Falls ein Account mit dieser E-Mail-Adresse existiert, wurde ein Link für das Zurücksetzen des Passworts
          geschickt.'
          }}
        </mat-card-subtitle>
      </div>
    </mat-card-content>
  </mat-card>
</div>
